/*=========================================================================================
  File Name: moduleTraineeActions.js
  Description: Trainee Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    
    return new Promise((resolve, reject) => {
      axios.post("api/Trainee/AddTrainee", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  


  fetchDataListItemsByFilter({ commit },search) {
    
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetAllByFilter?search="+search)
        .then((response) => {
          commit('SET_Trainees', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetTraineeSchedule({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/Trainee/GetTraineeSchedule", search)
        .then((response) => {
          commit('SET_TraineeSchedule', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetTraineeScheduleByTraineeID({ commit }, search) {
    
    return new Promise((resolve, reject) => {
      axios.post("api/Trainee/GetTraineeScheduleByTraineeID", search)
        .then((response) => {
          commit('SET_TraineeSchedule', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItems({ commit }) { 
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetAll")
        .then((response) => {
          commit('SET_Trainees', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

   traineeSearch({ commit },search) { 
    return new Promise((resolve, reject) => {
      axios.post("api/Trainee/TraineeSearch",search)
        .then((response) => {
          commit('SET_Trainees', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  traineeHomeData({ commit }) { 
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetHomeModel")
        .then((response) => {
          commit('SET_Home', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAllObtainCourses(context,id) { 
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetAllObtainCourses?traineeID="+id)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetTraineeCourseClassByInstructorID({ commit }) {
    
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetTraineeAssignCourseClassByInstructor")
        .then((response) => {
          commit('SET_Trainees', response.data)
          
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetTraineeByCustomer({ commit }) { 
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetTraineeByCustomer")
        .then((response) => {
          commit('SET_Trainees', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItem(context, item) {
    return new Promise((resolve, reject) => {
      axios.put("api/Trainee/UpdateTrainee?ID="+item.ID, item)
        .then((response) => {
          //commit('UPDATE_Trainee', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/GetTrainee?ID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SetAsNotNew(context,itemid){
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/SetAsNotNew?ID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAllTraineeCourses( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/GetAllTraineeCourses?traineeID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  GetAllTraineeCourseRequest( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/GetAllTraineeCourseRequest?traineeID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  GetAllTraineeInvoices( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/GetAllTraineeInvoices?traineeID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  GetAllTraineeExams( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/GetAllTraineeExams?traineeID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  getTraineeAdvertisementNotify({commit} ,context) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/getTraineeAdvertisementNotify")
        .then((response) => {
          commit('SET_Mails', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetAllTraineeCertificate( context) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/GetAllTraineeCertificate")
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAllCourseReview( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/GetAllCourseReview?traineeID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetLoginTrainee(context) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/Trainee/GetLoginTrainee")
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Trainee/DeleteTrainee?ID="+item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 

  removeContact(context, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Trainee/DeleteTraineeContact?ID="+item.ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeAttachment(context, ID) {
    
    return new Promise((resolve, reject) => {
      axios.delete("api/Trainee/DeleteTraineeAttachment?ID="+ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  Registration(context, item) {
    
    return new Promise((resolve, reject) => {
      axios.post("/RegistrationUser", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  
  removeEducation(context, ID) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Trainee/DeleteTraineeEducation?ID="+ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetPassedTraineeByCourseClassID( { commit },itemid) { 
    return new Promise((resolve, reject) => {
      axios.get("API/CourseClass/GetPassedTraineeByCourseClassID?courseClassID="+itemid)
        .then((response) => {
          commit('SET_Trainees', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetTraineeByCourseClassID( { commit },itemid) { 
    return new Promise((resolve, reject) => {
      debugger
      axios.get("API/Trainee/GetTraineeByCourseClassID?courseClassID="+itemid)
        .then((response) => {
          commit('SET_Trainees', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetTraineeByCourseClassExamID( { commit },itemid) { 
    return new Promise((resolve, reject) => {
      debugger
      axios.get("API/Trainee/GetTraineeByCourseClassExamID?courseClassExamID="+itemid)
        .then((response) => {
          commit('SET_Trainees', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getTraineesAdmissionTestForCourseRegistration( { commit },itemid) { 
    return new Promise((resolve, reject) => {
      debugger
      axios.get("API/Trainee/getTraineesAdmissionTestForCourseRegistration?CourseRegistrationID="+itemid)
        .then((response) => {
          commit('SET_Trainees', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetTraineePassDetail(context,data) { 
     
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetTraineePassDetail",
      {
        params:{
          TraineeID:data.TraineeID,
          CourseClassID:data.CourseClassID
        }
      }).then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  GetTraineePractical(context,data) { 
     
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetTraineePractical",
      {
        params:{
          TraineeID:data.TraineeID,
          CourseClassID:data.CourseClassID
        }
      })
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetTraineeCertificate(context,data) { 
     
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/GetTraineeCertificate",
      {
        params:{
          TraineeID: data.TraineeID,
          CourseClassID: data.CourseClassID
        }
      })
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SaveTraineeCertificate(context,data) { 
     
    return new Promise((resolve, reject) => {
      axios.get("api/Trainee/SaveTraineeCertificate",
      {
        params:{
          TraineeID:data.TraineeID,
          CourseClassID:data.CourseClassID,
          Certificate:data.Certificate
        }
      })
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SaveTraineePractical(context,data) { 
     
    return new Promise((resolve, reject) => {
      axios.post("api/Trainee/SaveTraineePractical",data)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  SetIsDownloadCertificate( context,CertificateTrainee) { 
    
    return new Promise((resolve, reject) => {
      axios.post("API/Trainee/SetIsDownloadCertificate",CertificateTrainee)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  CordinatorSendMail( context,mailData) { 
    
    return new Promise((resolve, reject) => {
      axios.post("API/Trainee/CordinatorSendMail",mailData)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  CordinatorSendChaimMail( context,mailData) { 
    
    return new Promise((resolve, reject) => {
      axios.post("API/Trainee/CordinatorSendChaimMail",mailData)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetAnnualPlanHtmlByIds( context,annualPlans) { 
    return new Promise((resolve, reject) => {
      axios.post("API/Trainee/GetAnnualPlanHtmlByIds",annualPlans)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetAnnualPlanMailChaimpHtmlByIds( context,annualPlans) { 
    return new Promise((resolve, reject) => {
      axios.post("API/Trainee/GetAnnualPlanMailChaimpHtmlByIds",annualPlans)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SendGeneralNotification( context,mailData) { 
    
    return new Promise((resolve, reject) => {
      axios.post("API/Trainee/SendGeneralNotification",mailData)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SubmitAllAdvertisementNotifyAsRead( context,ListOfAdvertisement) { 
    debugger
    return new Promise((resolve, reject) => {
      axios.post("API/Customer/SubmitAllAdvertisementNotifyAsRead",ListOfAdvertisement)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SubmitAdvertisementNotifyAsRead( context,ListOfAdvertisement) { 
    debugger
    return new Promise((resolve, reject) => {
      axios.post("API/Customer/SubmitAdvertisementNotifyAsRead",ListOfAdvertisement)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
